<template>
  <div>
    <vs-popup
      fullscreen
      :active.sync="phoneResetStep1Popup"
      class="full-popup residence"
    >
      <div class="fullscreen-wrapper">
        <h1>{{ $t("verificationReset.title") }}</h1>

        <div class="mt10">
          OTP 인증 앱 복구코드 분실 등의 이유로 로그인을 하실 수 없는 경우
          아래의 인증서류를 통해 본인확인을 진행하세요. 비대면 인증 확인이
          완료된 회원님에 한하여 OTP 인증 앱 등록정보를 다시 등록하실 수 있도록
          기존 정보를 초기화 처리하여 드립니다.
        </div>
        <div class="mt10">
          <p class="bold">OTP 초기화 방법</p>
          - 아래 인증서류를 등록하여 주세요 신청된 본인확인 요청은 Flybit
          운영자의 인증서류 확인을 거쳐 최종적으로 인증 완료됩니다. 인증
          완료까지 최대 며칠의 기간이 소요될 수 있습니다.<br />
          - 본인확인이 완료된 회원님께 본인인증 정보를 초기화 할 수 있는 인증
          메일을 발송해 드립니다.<br />
          - 수신된 메일의 확인 후 OTP 인증 없이 로그인 하세요.
        </div>

        <p class="bold mt20">[ 본인 확인 인증 서류 ]</p>
        <p class="bold mt10">1. 신분증(주민등록증, 운전면허등록증 등) 촬영본</p>
        <div class="mt10">
          <div class="guide-table" v-for="(item, index) in items" :key="index">
            <div class="title" v-html="item.title" />
            <div class="desc" v-html="item.desc" />
          </div>
        </div>
        <p class="mt10">※ 신분증에 OTP 초기화 신청 날짜를 기재하여 주세요.</p>
        <div>
          <p class="bold mt10">2. 주민등록등본 촬영본</p>
          - 주민등록등본 촬영본의 주민등록번호 뒤 6자리는 보이지 않게
          가려주세요.<br />
          - 회원 본인의 이름과 주소지가 함께 기재되어 있어야 합니다.<br />
          - 최근 90일 이내에 발급된 주민등록등본만 가능합니다.
        </div>
        <p class="warning">
          {{ $t("verificationReset.verificationDocuments.notice[0]") }}
          <br />
          {{ $t("verificationReset.verificationDocuments.notice[1]") }}
        </p>
      </div>
      <div class="btn-bottom-area">
        <vs-button @click="phoneResetPopupClose">
          {{ this.$t("confirm.cancel") }}
        </vs-button>
        <vs-button @click="phoneResetPopupOpen">
          {{
            this.$t("verificationReset.verificationDocuments.submitDocument")
          }}
        </vs-button>
      </div>
    </vs-popup>
    <vs-popup
      fullscreen
      :active.sync="phoneResetStep2Popup"
      class="full-popup residence"
    >
      <div class="fullscreen-wrapper">
        <h1>{{ $t("verificationReset.title") }}</h1>

        <ul class="ul">
          <li class="li">
            <p>
              1. {{ $t("verificationReset.verificationDocuments.id.title") }}
            </p>
            <div class="id-card">
              <vs-input
                placeholder="이미지 파일 업로드"
                class="input-block input-custom"
                disabled
                :value="files.idCard.name"
              ></vs-input>
              <input
                type="file"
                name="idCard"
                ref="idCardImg"
                style="display: none"
                @change="setFile"
              />
              <vs-button
                class="btn-agree-view"
                @click="$refs.idCardImg.click()"
                >{{ $t("verificationReset.residence.findFile") }}</vs-button
              >
            </div>
          </li>
          <div class="img-wrap mt10" style="width: 100%" flex fjb>
            <img
              src="~@/assets/img/common/idcard.png"
              alt=""
              style="width: 49%"
            />
            <img
              src="~@/assets/img/common/driverlicense.png"
              alt=""
              style="width: 49%"
            />
          </div>
          <div class="mt10">
            <div
              class="guide-table"
              v-for="(item, index) in items"
              :key="index"
            >
              <div class="title" v-html="item.title" />
              <div class="desc" v-html="item.desc" />
            </div>
            <p class="mt10">
              ※ 신분증에 OTP 초기화 신청 날짜를 기재하여 주세요.
            </p>
          </div>

          <li class="li mt15">
            <p>
              <!--{{ $t("verificationReset.verificationDocuments.photo.title") }}-->
              2. 주민등록등본 촬영본
            </p>
            <div class="id-card">
              <vs-input
                placeholder="이미지 파일 업로드"
                class="input-block input-custom"
                disabled
                :value="files.withId.name"
              ></vs-input>
              <input
                type="file"
                name="withId"
                ref="withIdImg"
                style="display: none"
                @change="setFile"
              />
              <vs-button
                class="btn-agree-view"
                @click="$refs.withIdImg.click()"
                >{{ $t("verificationReset.residence.findFile") }}</vs-button
              >
            </div>
            <!-- <ul class="bill-help">
              <li class="bill">신분증에 거주지 증명 신청 날짜를 기재하여 주세요.</li>
              <li class="bill">신분증에 기재된 날짜가 위 ①번 촬영본에 기재된 날짜와 일치하여야 합니다.</li>
            </ul>-->
          </li>
        </ul>
        <div class="img-wrap mt10" style="width: 100%" flex fjb>
          <img
            src="~@/assets/img/common/idFile.png"
            alt=""
            style="width: 100%"
          />
        </div>
        <p style="font-size: 14px;" class="mt10">
          - 주민등록등본 촬영본의 주민등록번호 뒤 6자리는 보이지 않게
          가려주세요.<br />
          - 회원 본인의 이름과 주소지가 함께 기재되어 있어야 합니다.<br />
          - 최근 90일 이내에 발급된 주민등록등본만 가능합니다.
        </p>
        <p class="warning">
          {{ $t("verificationReset.verificationDocuments.notice[0]") }}
          <br />
          {{ $t("verificationReset.verificationDocuments.notice[1]") }}
        </p>
        <p class="email-check">
          {{ $t("verificationReset.verificationDocuments.emailCheck") }}
        </p>
      </div>
      <div class="btn-bottom-area">
        <vs-button @click="phoneResetPopupClose">
          {{ this.$t("confirm.cancel") }}
        </vs-button>
        <vs-button @click.prevent="requestPhoneReset">
          {{
            this.$t("verificationReset.verificationDocuments.submitDocument")
          }}
        </vs-button>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import Api from "@/common/Api";
export default {
  name: "phoneReset",
  props: ["phone-reset-step-popup"],
  watch: {
    phoneResetStepPopup: function() {
      this.phoneResetStep1Popup = this.phoneResetStepPopup;
    },
    phoneResetStep1Popup: function() {
      if (!this.phoneResetStep1Popup) {
        this.$emit("phone-reset-popup-cancel");
      }
    },
  },
  data() {
    return {
      phoneResetStep1Popup: false,
      phoneResetStep2Popup: false,
      files: {
        idCard: {},
        withId: {},
      },
      items: [
        { title: "", desc: "마스킹 기준" },
        {
          title: "주민등록증",
          desc: "1) 주민등록번호 뒷자리 6자리<br />2) 발급일자 전체",
        },
        {
          title: "운전면허증",
          desc:
            "1) 운전변허번호 뒷자리 6자리<br />2) 주민등록번호 뒷자리 6자리<br/>3) 일련번호 전체<br/>4) 발급일자 전체",
        },
      ],
    };
  },
  methods: {
    setFile($event) {
      console.log("$event", $event);
      const { name, files } = $event.target;
      console.log("name", name, files);
      if (!files.length) {
        return false;
      }
      // size 체크
      const fileMaxSize = 10485760;
      if (
        files[0].size > fileMaxSize ||
        !/\.(jpg|jpeg|png)$/i.test(files[0].name)
      ) {
        this.$vs.notify({
          title: this.$t("verificationReset.title"),
          text: this.$t("verificationReset.residence.notice"),
          position: "top-right",
          color: "danger",
        });
        return false;
      }
      this.files[name] = files[0];
      console.log("this.files[name]", this.files[name]);
    },
    async requestPhoneReset() {
      // 두 파일 다 업로드 되었는지 판단
      if (_.some(this.files, (f) => !(f instanceof File))) {
        this.$vs.notify({
          title: this.$t("verificationReset.title"),
          text: "인증 서류를 모두 업로드 해주세요.",
          position: "top-right",
          color: "danger",
        });
        return false;
      }

      try {
        await Api.User.RequestPhoneReset({
          token: this.$route.params.token,
          upfile1: this.files.idCard,
          upfile2: this.files.withId,
        });
        this.$vs.notify({
          title: this.$t("verificationReset.title"),
          text: this.$t("notice.content.verificationSubmissionComplete"),
          position: "top-left",
        });

        // this.$store.dispatch('updateUserInfo');
        this.phoneResetPopupClose();
        setTimeout(() => {
          this.$router.replace("/");
        }, 50);
      } catch (error) {
        this.$vs.notify({
          text: "[" + error.code + "]" + error.msg,
          position: "top-left",
        });
      }
    },
    phoneResetPopupOpen() {
      this.phoneResetStep1Popup = false;
      this.phoneResetStep2Popup = true;
    },
    phoneResetPopupClose() {
      this.phoneResetStep1Popup = false;
      this.phoneResetStep2Popup = false;
      this.files = {
        idCard: {},
        withId: {},
      };
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/color_palette.scss";

.email-check {
  margin-top: 10px;
  font-size: 14px;
  color: #eb3246;
}
.table {
  display: flex;
  .left {
    flex: 1;
    border: 1px solid $BlueGray600;
    border-width: 0 1px 1px 1px;
    padding: 5px;
    font-size: 14px;
  }
  .right {
    flex: 2;
    border: 1px solid $BlueGray600;
    border-width: 0 1px 1px 0;
    padding: 5px;
    font-size: 14px;
  }
  &:first-of-type {
    .left {
      border-top: 1px solid $BlueGray600;
    }
    .right {
      border-top: 1px solid $BlueGray600;
    }
  }
}
</style>
